import React, { Component } from "react";
import InitialBalance from "../../../components/InitialBalance/InitialBalance";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : OvertimeForm
Description : Componente que invoca al componente Overtime, para la consulta y creación de horas extra.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Overtime
================================================================================ */
class InitialBalanceForm extends Component {
    render() {
        return (
            <InitialBalance />
        )
    }
}

export default InitialBalanceForm;
